import type { ReactNode } from "react";

export interface SectionHeaderProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  lede?: ReactNode;
  action?: ReactNode;
  number?: number | string | null;
}

export function SectionHeader({ eyebrow, title, lede, action, number }: SectionHeaderProps) {
  return (
    <header className="mb-10">
      <div className="hr-thick mb-5" />
      <div className="flex items-end justify-between gap-8 flex-wrap">
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-4 mb-3">
            {number != null && (
              <span className="mono text-[12px] text-[var(--ink-3)] tabular">§{number}</span>
            )}
            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          </div>
          <h1 className="display-3 text-[var(--ink)]">{title}</h1>
          {lede && <p className="lede mt-4 max-w-3xl">{lede}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </header>
  );
}
